<template>
    <div id="app">
        <div class="mod-wrapper">
            <div class="mod-wrap" >
                <header-wrapper v-show="routerName != 'showroom' && routerName !='appIndex'">
                    <logo/>
                    <header-menu/>
                    <header-about/>
                </header-wrapper>
                <router-view v-if="isRouterAlive" />
                <footer-component :footData="footData" v-show="routerName != 'showroom' && routerName !='appIndex'" />
            </div>
        </div>
    </div>
</template>

<script>
import './html/components/common/reset.scss';
import './html/components/common/common.scss';
import './html/components/footer/footer.scss';

import headerWrapper from './components/header-wrapper/header-wrapper';
import logo from './components/logo/logo';
import headerMenu from './components/header-menu/header-menu';
import headerAbout from './components/header-about/header-about';
import footerComponent from './components/footer/footer';

import { mapMutations, mapState } from 'vuex';

import { getUserInfo } from './api/index.js';

import { footer } from './api/index';
export default {
    provide () {
        return {
            reload: this.reload
        }
    },
    components: {
        headerWrapper,
        logo,
        headerMenu,
        headerAbout,
        footerComponent
    },
    data() {
        return {
            footData: [],
            routerName:"",
            isRouterAlive: true
        };
    },
    computed: {
        ...mapState(['userInfo'])
    },
    methods: {
        ...mapMutations(['setUserInfo']),
        async getFooter() {
            let res = await footer();
            if (res.Type == 'Success') {
                this.footData = res.Data;
            }
            // console.log(res);
        },
        async getUserInfo() {
            // console.log(this.userInfo)
            if (this.userInfo == null) {
                let res = await getUserInfo();
                if (res.Type == 'Success') {
                    this.setUserInfo(res.Data.userInfo);
                }
            }
        },
        reload () {
            this.isRouterAlive = false
            this.$nextTick(function () {
                this.isRouterAlive = true
            })
        },
    },
    created() {
        this.getFooter();
        // debugger;
        this.setUserInfo();
        this.getUserInfo();
        // console.log(this.userInfo);
    },
    watch:{
        $route(to,from){
            this.routerName = to.name
        }
    }
};
</script>

<style>
/* 弹窗样式 */
.notify-btn-primary{
    background:#4cde9f !important;
    border-color:#4cde9f !important;
}
.vl-notify-btns{
    margin-bottom:20px !important;
}

/* elementui组件样式 */
#app .el-pagination{
    text-align:center;
}
#app .el-pagination .btn-prev,
#app .el-pagination .btn-next{
    width:88px;
    height:34px;
    background:#e6e6e6;
}
#app .el-pagination .btn-prev span,
#app .el-pagination .btn-next span{
    color:#666;
    font-size:18px;
}
#app .el-pagination .el-pager .number{
    width:34px;
    height:34px;
    line-height:34px;
    background:#e6e6e6 ;
    color:#666666 ;
    font-size:18px;
    font-weight:normal;
}
#app .el-pagination .el-pager .number.active{
    color:#fff;
    background:#4bde9e;
}
#app .el-pagination .el-pager .btn-quickprev,
#app .el-pagination .el-pager .btn-quicknext{
    height:34px;
    line-height:34px;
    color:#666;
}
.del-p{
  position: absolute;
  width: 20px;
  height: 20px;
  background: url('./html/pages/originality/createQe/images/del.png') no-repeat;
  background-size: 100% 100%;
  right: 0;
  top: 0;
}
</style>
